webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(10);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _store = __webpack_require__(9);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  store: _store2.default,
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo.8dfff7f.png";

/***/ },
/* 4 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 5 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 6 */,
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lowpoly = __webpack_require__(2);
	
	var _lowpoly2 = _interopRequireDefault(_lowpoly);
	
	var _counter = __webpack_require__(11);
	
	var _counter2 = _interopRequireDefault(_counter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  data: function data() {
	    return {
	      src: '',
	      working: false
	    };
	  },
	
	  components: {
	    Counter: _counter2.default
	  },
	  methods: {
	    upload: function upload() {
	      document.querySelector('#upload-btn').click();
	    },
	    getFile: function getFile(e) {
	      var _this = this;
	
	      var reader = new FileReader();
	      var file = e.target;
	      reader.onload = function () {
	        _this.src = reader.result;
	      };
	      reader.readAsDataURL(file.files[0]);
	    },
	    styling: function styling() {
	      var _this2 = this;
	
	      this.working = true;
	      var options = this.$store.state.options;
	      var lowpoly = new _lowpoly2.default(this.src, {
	        EDGE_DETECT_VALUE: options.ddv,
	        POINT_RATE: options.pr,
	        POINT_MAX_NUM: options.pmn,
	        BLUR_SIZE: options.bs,
	        EDGE_SIZE: options.es,
	        PIXEL_LIMIT: options.pl
	      }).init().then(function (data) {
	        _this2.src = data;
	        _this2.working = false;
	      });
	    }
	  }
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['type', 'order'],
	  computed: {
	    innerNum: function innerNum() {
	      return this.$store.state.options[this.type];
	    }
	  },
	  methods: {
	    increment: function increment() {
	      var obj = {
	        type: this.type,
	        order: this.order,
	        option: 'increment'
	      };
	      this.$store.dispatch('updateOptions', obj);
	    },
	    decrement: function decrement() {
	      var obj = {
	        type: this.type,
	        order: this.order,
	        option: 'decrement'
	      };
	      this.$store.dispatch('updateOptions', obj);
	    }
	  }
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(6);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
		state: {
			options: {
				ddv: 80,
				pr: 0.075,
				pmn: 5500,
				bs: 2,
				es: 8,
				pl: 200000
			}
		},
		mutations: {
			UPDATE_OPTIONS: function UPDATE_OPTIONS(state, _ref) {
				var type = _ref.type;
				var order = _ref.order;
				var option = _ref.option;
	
				if (option === 'increment') {
					state.options[type] += parseFloat(order);
				} else if (option === 'decrement' && state.options[type] > 0) {
					state.options[type] -= parseFloat(order);
				}
			}
		},
		actions: {
			updateOptions: function updateOptions(_ref2, obj) {
				var commit = _ref2.commit;
	
				commit('UPDATE_OPTIONS', obj);
			}
		}
	});

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(4)
	
	/* script */
	__vue_exports__ = __webpack_require__(7)
	
	/* template */
	var __vue_template__ = __webpack_require__(12)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(5)
	
	/* script */
	__vue_exports__ = __webpack_require__(8)
	
	/* template */
	var __vue_template__ = __webpack_require__(13)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c4db1830"
	
	module.exports = __vue_exports__


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_h('div', {
	    staticClass: "head"
	  }, [_m(0), " ", _h('div', {
	    staticClass: "output"
	  }, [_h('img', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (src),
	      expression: "src"
	    }],
	    attrs: {
	      "src": src,
	      "alt": "Select a picture"
	    },
	    on: {
	      "click": upload
	    }
	  }), " ", _h('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!src),
	      expression: "!src"
	    }],
	    staticClass: "uploader",
	    on: {
	      "click": upload
	    }
	  }, ["Select a picture"]), " ", _h('input', {
	    attrs: {
	      "type": "file",
	      "capture": "camera",
	      "accept": "image/*",
	      "id": "upload-btn",
	      "hidden": ""
	    },
	    on: {
	      "change": getFile
	    }
	  })])]), " ", _h('Counter', {
	    attrs: {
	      "type": "ddv",
	      "order": "5"
	    }
	  }, [_m(1)]), " ", _h('Counter', {
	    attrs: {
	      "type": "pr",
	      "order": "0.005"
	    }
	  }, [_m(2)]), " ", _h('Counter', {
	    attrs: {
	      "type": "pmn",
	      "order": "100"
	    }
	  }, [_m(3)]), " ", _h('Counter', {
	    attrs: {
	      "type": "bs",
	      "order": "1"
	    }
	  }, [_m(4)]), " ", _h('Counter', {
	    attrs: {
	      "type": "es",
	      "order": "1"
	    }
	  }, [_m(5)]), " ", _h('Counter', {
	    attrs: {
	      "type": "pl",
	      "order": "1000"
	    }
	  }, [_m(6)]), " ", _h('button', {
	    staticClass: "generate-btn",
	    on: {
	      "click": styling
	    }
	  }, [_h('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (working),
	      expression: "working"
	    }],
	    staticClass: "spinner"
	  }, ["―"]), " ", _h('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!working),
	      expression: "!working"
	    }]
	  }, ["Generate"])])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('h1', ["\n      Low-Poly\n      ", _h('img', {
	    attrs: {
	      "src": __webpack_require__(3),
	      "alt": ""
	    }
	  })])
	}},function (){with(this) {
	  return _h('span', {
	    staticClass: "counter-name"
	  }, ["Edge detact value:"])
	}},function (){with(this) {
	  return _h('span', {
	    staticClass: "counter-name"
	  }, ["Point rate:"])
	}},function (){with(this) {
	  return _h('span', {
	    staticClass: "counter-name"
	  }, ["Point max number:"])
	}},function (){with(this) {
	  return _h('span', {
	    staticClass: "counter-name"
	  }, ["Blur size:"])
	}},function (){with(this) {
	  return _h('span', {
	    staticClass: "counter-name"
	  }, ["Edge size:"])
	}},function (){with(this) {
	  return _h('span', {
	    staticClass: "counter-name"
	  }, ["Pixel limit:"])
	}}]}

/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "counter"
	  }, [_t("default"), " ", _h('span', {
	    staticClass: "counter-content"
	  }, [_h('span', {
	    staticClass: "btn",
	    on: {
	      "click": increment
	    }
	  }, ["+"]), " ", _h('span', {
	    staticClass: "input"
	  }, [_s(innerNum)]), " ", _h('span', {
	    staticClass: "btn",
	    on: {
	      "click": decrement
	    }
	  }, ["-"])])])
	}},staticRenderFns: []}

/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.ee92136eca844e38ec97.js
 **/